import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { adapter } from "@/services/db";
import { useDoc } from "@/hooks/useDoc";

export const GroupLeadsSwitch = () => {
  const { data } = useDoc("lead_settings", "current");
  const [busy, setBusy] = useState(false);
  const [local, setLocal] = useState(null);
  const on = local ?? (data?.group_leads_enabled !== false);
  const toggle = async (v) => {
    setBusy(true); setLocal(v);
    try { await adapter.set("lead_settings", "current", { group_leads_enabled: v, updated_at: new Date().toISOString() }); toast.success(v ? "Group leads ON — web shows 'How do you want to hire?'" : "Group leads OFF — question hidden on web"); }
    catch (e) { setLocal(null); toast.error(e?.code === "permission-denied" ? "Publish the lead_settings rule first" : e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-border bg-card px-3.5 py-2.5" data-testid="group-leads-box">
      <div className="text-[11px] uppercase tracking-wide text-muted-foreground">Group leads</div>
      <div className="flex items-center gap-2 mt-1">
        <span data-testid="group-leads-label" className={`text-xs font-semibold px-2 py-0.5 rounded-full ${on ? "bg-emerald-500/15 text-emerald-500" : "bg-muted text-muted-foreground"}`}>{on ? "ON" : "OFF"}</span>
        <Switch data-testid="group-leads-switch" checked={on} disabled={busy} onCheckedChange={toggle} />
      </div>
      <p className="text-[10px] text-muted-foreground mt-1 max-w-[220px]">Off hides “How do you want to hire?” on the website</p>
    </div>
  );
};
